// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__17ZuT","list":"PatternAutocomplete_list__2nUkg"};